import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";
import { DealDraftCondition } from "../../store/common/aiCopilot";

const getChat = (prompt: string, sessionId: string, signal: AbortSignal) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.aiCopilot.chat;

  return fetch(
    `${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`,
    {
      ...RequestOptions('POST', JSON.stringify({ prompt, sessionId }), { accept: 'text/event-stream' }),
      signal,
    }
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    );
};

const getDealDraft = (draftId: string, signal?: AbortSignal) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.aiCopilot.dealDraft.replace('{id}', encodeURIComponent(draftId));

  return fetch(
    `${endpoint}${authenticity_token ? `?authenticity_token=${authenticity_token}` : ''}`,
    {
      ...RequestOptions('GET'),
      signal,
    }
  )
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    );
};

const applyDealDraft = (draftId: string, condition?: DealDraftCondition) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.aiCopilot.applyDealDraft.replace('{id}', encodeURIComponent(draftId));

  const payload = {
    authenticity_token: authenticity_token,
    ...(condition ? { condition } : {}),
  };

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    );
};

export const aiCopilotService = {
  getChat,
  getDealDraft,
  applyDealDraft,
};
